import type { ApiCallParams, DeviceIdentityLogger } from '../types'

export default class DeviceIdentity {
  apiCall: (params: ApiCallParams) => Promise<unknown>
  logger: DeviceIdentityLogger

  constructor ({ apiCall, logger }: { apiCall: (params: ApiCallParams) => Promise<unknown>; logger: DeviceIdentityLogger }) {
    this.apiCall = apiCall
    this.logger = logger
  }

  registerToken (_params?: { businessId?: string | number; token?: unknown }): void {
    this.logger.error('registerToken: method not implemented')
  }

  clearToken (_params?: { businessId?: string | number; token?: unknown }): void {
    this.logger.error('clearToken: method not implemented')
  }
}
